import { render, staticRenderFns } from "./PortalLayout.vue?vue&type=template&id=2c7b3c4a&scoped=true&"
import script from "./PortalLayout.vue?vue&type=script&lang=ts&"
export * from "./PortalLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PortalLayout.vue?vue&type=style&index=0&id=2c7b3c4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b3c4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7b3c4a')) {
      api.createRecord('2c7b3c4a', component.options)
    } else {
      api.reload('2c7b3c4a', component.options)
    }
    module.hot.accept("./PortalLayout.vue?vue&type=template&id=2c7b3c4a&scoped=true&", function () {
      api.rerender('2c7b3c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/portal/PortalLayout.vue"
export default component.exports